(function () {
    'use strict';

    var app = angular.module('app');

    app.config(['$stateProvider', '$urlRouterProvider', 'commonConfigProvider', function ($stateProvider, $urlRouterProvider, commonConfigProvider) {
        var appRoot = commonConfigProvider.config.clientAppSrcPath;
        var authenticationProviderName = angular.copy(window.authenticationOrigin).providerName;

        $urlRouterProvider.otherwise('/');

        // Dev Routes
        if (authenticationProviderName == 'developer') {
            $stateProvider
                .state('home', {
                    url: '/',
                    templateUrl: appRoot + 'app/home/home.html',
                    data: {
                        settings: {
                            nav: 1,
                            titleResourceKey: 'Home',
                            iconClass: 'fa-home'
                        }
                    }
                });

        };

        // Tmx Store Routes
        if (authenticationProviderName == 'tmxstore') {
            $stateProvider.state('tmxstore', {
                url: '/tmxstore',
                templateUrl: appRoot + 'app/tmxstore/tmxstore.html',
                data: {
                    settings: {
                        titleResourceKey: 'Tmx Store',
                        iconClass: 'fa-space-shuttle'
                    }
                }
            });

            $urlRouterProvider.otherwise('/tmxstore');
        };

        // Open Routes
        $stateProvider.state('api', {
            abstract: true,
            url: '/api/{apiId:int}',
            template: '<div class="route-ui-view" ui-view></div>',
        })
        .state('api.operations', {
            url: '/operations',
            templateUrl: appRoot + 'app/api/operations.html'
        })
        .state('api.operationsDetail', {
            url: '/operations/{operationId}',
            templateUrl: appRoot + 'app/api/operationDetail.html'
        });
        $stateProvider.state('error', {
            url: '/error',
            templateUrl: appRoot + 'app/error/error.html',
            params: {
                errorReason: null
            },
        });

        
    }])
})();